import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from "vuex";
import { required, email, minLength, maxLength, numeric, alpha } from "vuelidate/lib/validators";
import { onlyLetters, onlyEmail, noSpecialChars } from "~/validators";
import { emailErrorMessagesMixin, stepForm, onlyNumbersMixin, onlyLettersMixin, documentNumberAndTypeFormMixin } from "~/mixins";
import { mapActions } from "vuex";
import { WarningError } from "~/abstractions/errors";
import loader from "../modals/loader";

export default {
  mixins: [emailErrorMessagesMixin, stepForm, onlyNumbersMixin, onlyLettersMixin, documentNumberAndTypeFormMixin],
  components: {
    loader: loader
  },
  data: function data() {
    var _$store$state$affilia = this.$store.state.affiliations.form.legalRepresentativeData,
        id = _$store$state$affilia.id,
        firstName = _$store$state$affilia.firstName,
        maternalName = _$store$state$affilia.maternalName,
        paternalName = _$store$state$affilia.paternalName,
        documentType = _$store$state$affilia.documentType,
        documentNumber = _$store$state$affilia.documentNumber,
        cellPhone = _$store$state$affilia.cellPhone,
        secondPhone = _$store$state$affilia.secondPhone,
        email = _$store$state$affilia.email,
        birthdate = _$store$state$affilia.birthdate,
        consultDate = _$store$state$affilia.consultDate;

    return {
      sending: false,
      // errorMessage: null,
      // ...this.$store.state.affiliations.form.legalRepresentativeData
      id: id,
      firstName: firstName,
      maternalName: maternalName,
      paternalName: paternalName,
      documentType: documentType,
      documentNumber: documentNumber,
      cellPhone: cellPhone,
      secondPhone: secondPhone,
      email: email,
      birthdate: birthdate ? this.$moment(birthdate).format("YYYY-MM-DD") : null,
      consultDate: consultDate

      // maxLengthDocumentNumber: 0,
    };
  },
  validations: function validations() {
    return {
      email: {
        required: required,
        // email,
        noSpecialChars: noSpecialChars('noSpecialChars'),
        emailValidate: onlyEmail('emailValidate')
      },
      firstName: {
        required: required,
        onlyLetters: onlyLetters("firstName")
      },
      paternalName: {
        required: required,
        onlyLetters: onlyLetters("paternalName")
      },
      maternalName: {
        required: required,
        onlyLetters: onlyLetters("maternalName")
      },
      documentNumber: {
        required: required,
        numeric: numeric,
        minLength: minLength(this.maxLengthDocumentNumber)
      },
      documentType: {
        required: required
      },
      cellPhone: {
        required: required,
        minLength: minLength(9),
        maxLength: maxLength(20),
        numeric: numeric
      },
      secondPhone: {
        required: required,
        minLength: minLength(6),
        maxLength: maxLength(20),
        numeric: numeric
      },
      birthdate: {
        required: required
      }
    };
  },


  methods: {
    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var results, messagePhone, timestamp, _ref2, existeCorreo, responseServer, _email, serverIp, _ref3, statusCode, internalStatusCode, internalStatusDescription;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.sending = true;
                this.$refs.loaderModal.showLoader();
                // servicio para verificar el telefono
                _context.next = 5;
                return _Promise.all([this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                  phone: this.cellPhone
                })]
                // this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                //   phone: this.secondPhone
                // }),
                );

              case 5:
                results = _context.sent;
                messagePhone = '';


                if (!results[0].code) messagePhone = "Tel\xE9fono Celular: " + results[0].message + "\n";
                // if (!results[1].code) messagePhone += `Segundo teléfono: ${results[1].message}`;

                if (!messagePhone) {
                  _context.next = 14;
                  break;
                }

                this.$swal('Aviso', messagePhone, 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context.next = 59;
                break;

              case 14:
                // servicio para verificar correo
                timestamp = Date.now();
                _context.next = 17;
                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                  transaccionId: timestamp,
                  correo: this.email.toLowerCase()
                });

              case 17:
                _ref2 = _context.sent;
                existeCorreo = _ref2.existeCorreo;
                responseServer = _ref2.responseServer;
                _email = _ref2.email;
                serverIp = _ref2.serverIp;


                console.log('datos : '.existeCorreo, responseServer, _email, serverIp);
                // Validando

                if (!(responseServer === 'Error')) {
                  _context.next = 29;
                  break;
                }

                this.$swal('Error', 'Error en el servicio. Vuelva a intentarlo mas tarde.', 'error');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context.next = 59;
                break;

              case 29:
                if (!existeCorreo) {
                  _context.next = 57;
                  break;
                }

                this.$v.$touch();

                if (!this.$v.$invalid) {
                  _context.next = 33;
                  break;
                }

                return _context.abrupt("return");

              case 33:
                _context.prev = 33;
                _context.next = 36;
                return this.$store.dispatch("affiliations/form/validateCrmContact", { // Paso 2 - Enviar request datos formulario y capturar respuesta
                  firstName: this.firstName,
                  maternalName: this.maternalName,
                  paternalName: this.paternalName,
                  documentNumber: this.documentNumber
                });

              case 36:
                _ref3 = _context.sent;
                statusCode = _ref3.statusCode;
                internalStatusCode = _ref3.internalStatusCode;
                internalStatusDescription = _ref3.internalStatusDescription;

                if (!(statusCode !== "0")) {
                  _context.next = 45;
                  break;
                }

                _context.t0 = internalStatusCode;
                _context.next = 44;
                break;

              case 44:
                throw new WarningError(internalStatusDescription);

              case 45:
                _context.next = 47;
                return this.$store.dispatch("affiliations/form/saveLegalRepresentativeData", {
                  firstName: this.firstName,
                  maternalName: this.maternalName,
                  paternalName: this.paternalName,
                  documentType: this.documentType,
                  documentNumber: this.documentNumber,
                  cellPhone: this.cellPhone,
                  secondPhone: this.secondPhone,
                  email: this.email,
                  birthdate: this.birthdate,
                  consultDate: this.$moment().format("YYYY-MM-DD")
                });

              case 47:
                _context.next = 53;
                break;

              case 49:
                _context.prev = 49;
                _context.t1 = _context["catch"](33);

                this.$controlMessage(_context.t1);
                this.$refs.loaderModal.closeLoader();

              case 53:
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context.next = 59;
                break;

              case 57:
                this.$swal('Aviso', "No existe el correo " + this.email + ", ingresar uno correcto.", 'warning');
                this.sending = false;

              case 59:
                _context.next = 66;
                break;

              case 61:
                _context.prev = 61;
                _context.t2 = _context["catch"](0);

                this.$swal('Aviso', "El correo ingresado tiene formato incorrecto.", 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                // console.log('Viendo el error xd: ', error)
                // this.$controlMessage(error);

              case 66:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 61], [33, 49]]);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    reset: function reset() {
      this.$v.$reset();
      this.email = "";
      this.emailSended = false;
    },
    changedDate: function changedDate(date) {
      var _this = this;

      setTimeout(function () {
        return _this.$refs.birthdateMenu.save(date);
      }, 500);
    }
  },
  computed: _extends({}, mapGetters({
    // documentTypes: ["master-data/documentTypes"]
    documentTypes: ["master-data/documentTypesLegalRepresentative"]
  }), {
    nameErrorMessages: function nameErrorMessages() {
      var errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.required && errors.push("Debes ingresar un nombre"), !this.$v.firstName.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    paternalNameErrorMessages: function paternalNameErrorMessages() {
      var errors = [];
      if (!this.$v.paternalName.$dirty) return errors;
      !this.$v.paternalName.required && errors.push("Debes ingresar un apellido"), !this.$v.paternalName.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    maternalNameErrorMessages: function maternalNameErrorMessages() {
      var errors = [];
      if (!this.$v.maternalName.$dirty) return errors;
      !this.$v.maternalName.required && errors.push("Debes ingresar un apellido");
      !this.$v.maternalName.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },

    // documentNumberErrorMessages() {
    //     const errors = []
    //     if (!this.$v.documentNumber.$dirty) return errors
    //     !this.$v.documentNumber.required && errors.push('Debes ingresar el número de documento')
    //     !this.$v.documentNumber.numeric && errors.push('Ingresa sólo números')
    //     !this.$v.documentNumber.minLength && errors.push(`Debes ingresar mínimo ${this.maxLengthDocumentNumber} números`)
    //     return errors
    // },
    cellPhoneErrorMessages: function cellPhoneErrorMessages() {
      var errors = [];
      if (!this.$v.cellPhone.$dirty) return errors;
      !this.$v.cellPhone.required && errors.push("Debes ingresar un número de teléfono");
      !this.$v.cellPhone.numeric && errors.push("Ingresa sólo números");
      !this.$v.cellPhone.minLength && errors.push("Debes ingresar mínimo 9 números");
      return errors;
    },
    secondPhoneErrorMessages: function secondPhoneErrorMessages() {
      var errors = [];
      if (!this.$v.secondPhone.$dirty) return errors;
      !this.$v.secondPhone.required && errors.push("Debes ingresar un número de teléfono");
      !this.$v.secondPhone.minLength && errors.push("Debes ingresar mínimo 6 números");
      !this.$v.secondPhone.numeric && errors.push("Ingresa sólo números");
      return errors;
    },
    birthdateErrorMessages: function birthdateErrorMessages() {
      var errors = [];
      if (!this.$v.birthdate.$dirty) return errors;
      !this.$v.birthdate.required && errors.push("Debes ingresar tu fecha de nacimiento");
      return errors;
    },
    calculateMaxDate: function calculateMaxDate() {
      var today = new Date();
      return new Date(today.setFullYear(today.getFullYear() - 18)).toISOString().substring(0, 10);
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/representative-data.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/representative-data.vue
// module chunks = 0 1 2 3